var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_84592",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_84592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5007 10.0003L7.25065 6.75033C7.09787 6.59755 7.02148 6.4031 7.02148 6.16699C7.02148 5.93088 7.09787 5.73644 7.25065 5.58366C7.40343 5.43088 7.59787 5.35449 7.83398 5.35449C8.0701 5.35449 8.26454 5.43088 8.41732 5.58366L12.2507 9.41699C12.334 9.50033 12.393 9.5906 12.4277 9.68783C12.4625 9.78505 12.4798 9.88921 12.4798 10.0003C12.4798 10.1114 12.4625 10.2156 12.4277 10.3128C12.393 10.41 12.334 10.5003 12.2507 10.5837L8.41732 14.417C8.26454 14.5698 8.0701 14.6462 7.83398 14.6462C7.59787 14.6462 7.40343 14.5698 7.25065 14.417C7.09787 14.2642 7.02148 14.0698 7.02148 13.8337C7.02148 13.5975 7.09787 13.4031 7.25065 13.2503L10.5007 10.0003Z",
    fill: "#40414C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.fdbfdf2f9924772d30fb6868c715108d.svg";
export { ForwardRef as ReactComponent };